import React from 'react';

import { Stack, Typography } from '@mui/material';

import { NO_STANDALONE_SCHEDULE_BRANDS } from '~/consts/brands';

import { formatViolation } from '../Detail/OfferBuilder/DealInformation/tabs/campaignSchedules/campaignScheduleViolationFormatter';
import type { CampaignScheduleImportViolation } from '../Detail/OfferBuilder/DealInformation/tabs/campaignSchedules/types';

type Props = {
  violations: Array<CampaignScheduleImportViolation>;
};

export default function ImportBlockersList({ violations }: Props) {
  const regionCoverageViolations = violations.filter((violation) => violation.code === 'missing_region_coverage');
  const hasAgentHubRegionCoverageViolation = regionCoverageViolations.some(
    (violation) => 'brand' in violation && NO_STANDALONE_SCHEDULE_BRANDS.includes(violation.brand),
  );
  const hasOtherRegionCoverageViolation = regionCoverageViolations.some(
    (violation) => 'brand' in violation && !NO_STANDALONE_SCHEDULE_BRANDS.includes(violation.brand),
  );

  return (
    <>
      <Stack component="ul" spacing={1} sx={{ m: 0, pl: 2.5 }}>
        {violations.map((violation, index) => (
          <Typography component="li" key={`${violation.code}-${index}`} sx={{ whiteSpace: 'pre-line' }} variant="body2">
            {formatViolation(violation)}
          </Typography>
        ))}
      </Stack>
      {hasAgentHubRegionCoverageViolation && (
        <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
          These schedules are generated automatically from Luxury Escapes&apos; own schedules — add the missing Luxury
          Escapes schedule types covering those regions in Salesforce, then re-import.
        </Typography>
      )}
      {hasOtherRegionCoverageViolation && (
        <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
          Add the missing schedule types covering those regions in Salesforce, then re-import.
        </Typography>
      )}
      {violations.some((violation) => violation.code === 'conflicting_source_records') && (
        <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
          Only one can be imported — reconcile these records in Salesforce, then re-import.
        </Typography>
      )}
    </>
  );
}
